export default __webpack_public_path__ + "static/media/notification-icon.7da94150.svg";